export const EVENT_LIVE_WITH_OUT_TIME_SHIFT_START_OVER = 'EVENT_LIVE_WITH_OUT_TIME_SHIFT_START_OVER';
export const EVENT_LIVE_WITH_TIME_SHIFT_START_OVER = 'EVENT_LIVE_WITH_TIME_SHIFT_START_OVER';
export const EVENT_PAST_WITH_OUT_TIME_SHIFT = 'EVENT_PAST_WITH_OUT_TIME_SHIFT';
export const EVENT_PAST_WITH_TIME_SHIFT = 'EVENT_PAST_WITH_TIME_SHIFT';
export const EVENT_PAST_WHITOUT_PLAY_PERMISSIONS = 'EVENT_PAST_WHITOUT_PLAY_PERMISSIONS';
export const EVENT_FUTURE = 'EVENT_FUTURE';
export const EVENT_LIVE_NOW = 'EVENT_LIVE_NOW';
export const EVENT_NO_TYPE = 'EVENT_NO_TYPE';
export const EVENT_WITH_NO_TIME_SHIFT = 'EVENT_WITH_NO_TIME_SHIFT';
export const EVENT_OUT_OF_TIMESHIFT = 'EVENT_OUT_OF_TIMESHIFT';
export const EVENT_MANIPULATE_KEY_LINEAL_CHANNELS = 'minutes';
export const EVENT_MANIPULATE_KEY_EPG = 'hours';
export const EVENT_CARD_FORMAT_TIME_EPG = 'YYYYMMDDHHmmss';

export const EVENT_CARD_ERROR_REQUEST = 'EVENT_CARD_ERROR_REQUEST';
export const EVENT_CARD_ERROR_EVENT_NOT_FOUND = 'EVENT_CARD_ERROR_EVENT_NOT_FOUND';
export const EVENT_CARD_ERROR_GROUP_ID_NOT_FOUND = 'EVENT_CARD_ERROR_GROUP_ID_NOT_FOUND';
export const EVENT_CARD_ERROR_RULES_NOT_ALLOWED = 'EVENT_CARD_ERROR_RULES_NOT_ALLOWED';
export const EVENT_CARD_ERROR_RULE_ONE_NOT_ALLOWED = 'EVENT_CARD_ERROR_RULE_ONE_NOT_ALLOWED';
export const EVENT_CARD_ERROR_RULE_TWO_NOT_ALLOWED = 'EVENT_CARD_ERROR_RULE_TWO_NOT_ALLOWED';
export const EVENT_CARD_ERROR_RULE_THREE_NOT_ALLOWED = 'EVENT_CARD_ERROR_RULE_THREE_NOT_ALLOWED';
export const EVENT_CARD_ERROR_RULE_FOUR_NOT_ALLOWED = 'EVENT_CARD_ERROR_RULE_FOUR_NOT_ALLOWED';

export const EVENT_CARD_ERROR_RECORD_RULE = 'EVENT_CARD_ERROR_RECORD_RULE';
